export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver al contenedor"])},
          "edit_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspección de calidad"])},
          "total": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])},
          "legend": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Leyenda"])}
        }
      }
    }
  })
}